import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Container, Grid, Stack } from '@mui/material';
import AuthContext from 'context/AuthContext';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import classes from 'styles/globalStyle.module.scss';

import AccountStatusCard from './AccountStatusCard';
import ActionCards from './ActionCards';
import AuditTrailCard from './AuditTrailCard';
import CustomerProfileCard from './CustomerProfileCard';

const toBool = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === 'yes' || normalized === '1';
  }
  return value === 1;
};

function CustomerDetailsPage({ customer, onBack }) {
  const { initiateUiResponse } = useContext(AuthContext);

  const [adminLocked, setAdminLocked] = useState(
    toBool(customer?.accountStatus?.adminSuspended ?? customer?.accountStatus?.adminSuspend)
  );

  console.log('initiateUiResponse', initiateUiResponse);
  return (
    <Container maxWidth="xl" className={classes.adminPortal} sx={{ px: { xs: 0, sm: 2, md: 3 } }}>
      <Box sx={{ py: { xs: 2, md: 4 } }}>
        {onBack && (
          <Button
            onClick={onBack}
            startIcon={
              <ArrowBackIcon
                sx={{
                  fontSize: { xs: '22px !important', sm: '26px !important', md: '30px !important' },
                }}
              />
            }
            disableRipple
            sx={{
              color: '#F5821F',
              fontSize: { xs: '24px !important', sm: '30px !important', md: '36px !important' },
              fontWeight: 700,
              height: 'auto',
              px: { xs: 0, sm: 1 },
              mb: { xs: 2, md: 4 },
            }}
          >
            Customer Details
          </Button>
        )}

        {/* Two columns only on large screens; the cards stack on tablets and phones. */}
        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} lg={5}>
            <Stack spacing={{ xs: 2, md: 3 }}>
              <CustomerProfileCard customer={customer} />
              <AuditTrailCard auditTrail={customer.auditTrail} />
            </Stack>
          </Grid>

          <Grid item xs={12} lg={7}>
            <Stack spacing={{ xs: 2, md: 3 }}>
              <AccountStatusCard customer={customer} adminLocked={adminLocked} />
              <ActionCards
                customer={customer}
                adminLocked={adminLocked}
                onAdminLockChange={setAdminLocked}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

CustomerDetailsPage.propTypes = {
  customer: PropTypes.object.isRequired,
  onBack: PropTypes.func,
};
CustomerDetailsPage.defaultProps = {
  onBack: null,
};
export default CustomerDetailsPage;
